const SYMBOL_MARKER = '{s}';
const VALUE_MARKER = '{v}';

const symbolDecorator = '<span class="currency">' + SYMBOL_MARKER + '</span>';

const AUD = {
    isoCode: 'AUD',
    symbol: '$',
    thousandsSeparator: ',',
    decimalSeparator: '.',
    decimalDigits: 0,
    formatPattern: symbolDecorator + VALUE_MARKER,
    formatPatternNoHTML: SYMBOL_MARKER + VALUE_MARKER,
    valueFormatter: value => value
};

const NZD = {
    isoCode: 'NZD',
    symbol: '$',
    thousandsSeparator: ',',
    decimalSeparator: '.',
    decimalDigits: 0,
    formatPattern: symbolDecorator + VALUE_MARKER,
    formatPatternNoHTML: SYMBOL_MARKER + VALUE_MARKER,
    valueFormatter: value => value
};

const EUR = {
    isoCode: 'EUR',
    symbol: '€',
    thousandsSeparator: '.',
    decimalSeparator: ',',
    decimalDigits: 0,
    formatPattern: symbolDecorator + ' ' + VALUE_MARKER,
    formatPatternNoHTML: SYMBOL_MARKER + ' ' + VALUE_MARKER,
    valueFormatter: value => value
};

const THB = {
    isoCode: 'THB',
    symbol: 'บาท',
    thousandsSeparator: ',',
    decimalSeparator: '.',
    decimalDigits: 0,
    formatPattern: VALUE_MARKER + ' ' + symbolDecorator,
    formatPatternNoHTML: VALUE_MARKER + ' ' + SYMBOL_MARKER,
    valueFormatter: value => value * 25
};

const MYR = {
    isoCode: 'MYR',
    symbol: 'RM',
    thousandsSeparator: ',',
    decimalSeparator: '.',
    decimalDigits: 0,
    formatPattern: VALUE_MARKER + ' ' + symbolDecorator,
    formatPatternNoHTML: VALUE_MARKER + ' ' + SYMBOL_MARKER,
    valueFormatter: value => value * 3
};

const IDR = {
    isoCode: 'IDR',
    symbol: 'Rp',
    thousandsSeparator: '.',
    decimalSeparator: ',',
    decimalDigits: 0,
    formatPattern: symbolDecorator + ' ' + VALUE_MARKER,
    formatPatternNoHTML: SYMBOL_MARKER + ' ' + VALUE_MARKER,
    valueFormatter: value => value
};

const CurrencySetup = {
    AUD,
    NZD,
    EUR,
    THB,
    MYR,
    IDR,
    defaultSetup: AUD,
    symbolMarker: SYMBOL_MARKER,
    valueMarker: VALUE_MARKER
};

export default CurrencySetup;
